export default __webpack_public_path__ + "static/media/Klarnalogo.c7863cf8.svg";